export default {
  generic: {
    enlarge: 'Click to enlarge the picture',
  },
  pages: {
    home: {
      location: 'ligging',
      see_all_gites: 'See all accommodations',
      see_all_massages: 'All massages',
      domain: {
        view_domain: 'Discover the domain',
      },
    },
    wellness: {
      all_massages: 'All massages',
    },
    contact: {
      location: 'Ligging',
      contact: 'Contact us',
      name: 'Name and First Name',
      email: 'Email',
      telephone: 'Telephone',
      message: 'Message',
      send: 'Send',
      required: 'required',
      reachability: 'How to come?',
    },
  },
  gites: {
    overview: {
      crumb: 'Gites and Glamping Lodges',
      title: 'Gites and Glamping Lodges',
      discover: 'Discover',
    },
    detail: {
      pictures: 'Pictures',
      facilities: 'Facilities',
      book_directly: 'Book now',
      from: 'Arrival',
      to: 'Departure',
      show_availability: 'Availability',
      availability: 'Show availability of',
      virtual_tour: 'Virtual tour',
    },
  },
  footer: {
    name: "Aux Quatrefeuilles d'Oc",
    help: 'Pratical information',
    social: 'Find us on',
    partner: 'Official partner of',
    reachable: 'Reachable on',
    copyright: 'Copyright',
    rights: 'All rights reserved',
  },
  components: {
    map: {
      calculate_route: 'Calculate my route',
      view_on_google_maps: 'View on Google Maps',
    },
    reviews: {
      title: 'What others are saying?',
      more: 'Discover more reviews!',
    },
    widget: {
      search: 'Availability',
      arrival: 'Arrival',
      departure: 'Departure',
      close: 'Close',
    },
  },
  groups: {
    more_information: 'More information',
    more_information_body: 'Contact us for more information or a detailed offer.',
  },
  error: {
    main_title: 'Page not found',
    title:
      'The page could not be loaded. Refresh your browser to reload the page. If the problem persists, please contact us.',
    body: 'Back to home',
  },
}
